import _ from 'lodash';
import { environment as base } from './environment.base';

const baseEnv = _.cloneDeep(base);

export const environment = _.merge(baseEnv, {
    name: 'development',
    plannerUrl: `${window.location.protocol}//${window.location.hostname}/optimize`,
    weatherStations: {
        weatherStationsApi:
            'https://ai-berthing.portline.eu/export/73c825c43977c096e18dacc1be9b846e83473262/sysinfo?list=parameters',
        serviceUrlParameters: '/export/73c825c43977c096e18dacc1be9b846e83473262/sysinfo?list=parameters',
        serviceUrlOperations: '/export/73c825c43977c096e18dacc1be9b846e83473262/sysinfo?list=operations',
        serviceUrlPlaces: '/export/73c825c43977c096e18dacc1be9b846e83473262/sysinfo?list=places',
        directUrlWithParams:
            'https://ai-berthing.portline.eu/export/73c825c43977c096e18dacc1be9b846e83473262/data?place_id={placeId}&interval_code=U&start_time={startTime}'
    },
    settings: {
        header: {
            environmentColor: 'color: #2cda43'
        },
        grid: {
            sort: {
                field: 'id',
                dir: 'desc'
            }
        }
    }
});
